import { Box, Typography } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { DateFormats, providerScheduleViewTypeRoute } from '@uplift/constants';
import { useTimezone } from '@uplift/contexts';
import { useL10n } from '@uplift/hooks';
import { CalendarDateService, formatTime } from '@uplift/services';
import { Button, StackableCard } from '@uplift/ui-v2';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { TodaysAppointmentWithPatient } from '../hooks/use-todays-appointments.hook';
import { useTodaySessionsStyles } from '../styles';

export type NextSessionProps = {
  nextSession: TodaysAppointmentWithPatient;
};

export const NextSession: React.FC<NextSessionProps> = ({ nextSession: { appointment } }) => {
  const l10n = useL10n();
  const { classes } = useTodaySessionsStyles();
  const timezone = useTimezone();

  const formattedSessionDate = useMemo(() => {
    const sessionDate = CalendarDateService.date(appointment.fromDatetime).tz(timezone);
    const endOfTomorrow = CalendarDateService.now(timezone).add(1, 'day').endOf('day');

    const isTomorrow = sessionDate.isBefore(endOfTomorrow);

    if (isTomorrow) {
      return `tomorrow at ${formatTime(sessionDate)}`;
    }
    return `on ${sessionDate.format(DateFormats.shortWeekdayShortMonthDate)}`;
  }, [ appointment.fromDatetime, timezone ]);

  return (
    <StackableCard>
      <Box className={classes.paperContent} textAlign="center">
        <Typography variant="h6" color="textSecondary">{l10n.sessions.yourNextSessionIs(formattedSessionDate)}</Typography>
        <Box mt={2}>
          <Button
            variant="text"
            color="secondary"
            endIcon={<ArrowForward />}
            className={classes.reviewScheduleButton}
            component={Link}
            to={providerScheduleViewTypeRoute.createLink({})}
          >
            {l10n.schedule.reviewYourSchedule}
          </Button>
        </Box>
      </Box>
    </StackableCard>
  );
};
